
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("lWS5G", function(module, exports) {
$parcel$export(module.exports, "MeatballMenu", () => $000f05509e90e8ab$export$ef4a0fdddd7eccb7);
$parcel$export(module.exports, "default", () => $000f05509e90e8ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $l3YLh = parcelRequire("l3YLh");

var $1qbKn = parcelRequire("1qbKn");

var $cKV9c = parcelRequire("cKV9c");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $9TSGc = parcelRequire("9TSGc");

var $c72mo = parcelRequire("c72mo");

var $662kQ = parcelRequire("662kQ");

var $4eIT5 = parcelRequire("4eIT5");

var $lJU2B = parcelRequire("lJU2B");
const $000f05509e90e8ab$var$errorBoundaryId = 'issue-operations-entrypoint';
const $000f05509e90e8ab$export$ef4a0fdddd7eccb7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownMenu'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'issueOperationsMeatballMenu');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: $000f05509e90e8ab$var$errorBoundaryId,
        packageName: "jiraIssueNavigatorIssueOperations",
        teamName: "empanada",
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4eIT5.Trigger), {
                label: formatMessage((0, $lJU2B.default).menuButtonLabel, {
                    issueKey: props.issueKey
                }),
                isDisabled: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
                id: $000f05509e90e8ab$var$errorBoundaryId,
                error: error
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c72mo.PropsProvider), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l3YLh.IssueOperationsCacheProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cKV9c.DropdownTrigger), {
        entryPoint: (0, $662kQ.meatballMenuEntrypoint),
        errorFallback: ({ error: error })=>{
            // Throw error back up the stack to be caught and logged by the JSErrorBoundary
            throw error;
        },
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4eIT5.Trigger), {
                issueId: props.issueId.toString(),
                label: formatMessage((0, $lJU2B.default).menuButtonLabel, {
                    issueKey: props.issueKey
                }),
                ...triggerProps,
                onClick: (...onClickProps)=>{
                    onClick();
                    triggerProps.onClick?.(...onClickProps);
                }
            }),
        placement: "bottom-end",
        shouldRenderToParent: true
    }))));
};
var $000f05509e90e8ab$export$2e2bcd8739ae039 = $000f05509e90e8ab$export$ef4a0fdddd7eccb7;

});
parcelRegister("l3YLh", function(module, exports) {
$parcel$export(module.exports, "issueOperationsCacheContext", () => $baa14237616d4ea7$export$95b3204bb3be1344);
$parcel$export(module.exports, "IssueOperationsCacheProvider", () => $baa14237616d4ea7$export$2b992d893f461b1e);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bJscI = parcelRequire("bJscI");
const $baa14237616d4ea7$var$initialState = {
    operationsAndActions: [
        {
            loading: false,
            loadFieldResources: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        },
        (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    ],
    mediaUploadPermissions: [
        {
            loading: false,
            error: false,
            permissions: null
        },
        (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    ]
};
const $baa14237616d4ea7$export$95b3204bb3be1344 = /*#__PURE__*/ (0, $eJOHy.createContext)($baa14237616d4ea7$var$initialState);
const $baa14237616d4ea7$var$IssueOperationsCacheProviderInner = ({ children: children })=>{
    const [operationsAndActions, setOperationsAndActions] = (0, $eJOHy.useState)($baa14237616d4ea7$var$initialState.operationsAndActions[0]);
    const [mediaUploadPermissions, setMediaUploadPermissions] = (0, $eJOHy.useState)($baa14237616d4ea7$var$initialState.mediaUploadPermissions[0]);
    const value = (0, $eJOHy.useMemo)(()=>({
            operationsAndActions: [
                operationsAndActions,
                setOperationsAndActions
            ],
            mediaUploadPermissions: [
                mediaUploadPermissions,
                setMediaUploadPermissions
            ]
        }), [
        operationsAndActions,
        mediaUploadPermissions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($baa14237616d4ea7$export$95b3204bb3be1344.Provider, {
        value: value
    }, children);
};
const $baa14237616d4ea7$export$2b992d893f461b1e = (0, $bJscI.componentWithFG)('empanada_nin_convert_issue_ops_to_entrypoint', $baa14237616d4ea7$var$IssueOperationsCacheProviderInner, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children));

});

parcelRegister("cKV9c", function(module, exports) {
$parcel$export(module.exports, "DropdownTrigger", () => $db027e76448a8745$export$e7eb525bc415b4b4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kmlzw = parcelRequire("kmlzw");

var $cdVOR = parcelRequire("cdVOR");

var $dYTIy = parcelRequire("dYTIy");

var $h5xWg = parcelRequire("h5xWg");

var $3wLc2 = parcelRequire("3wLc2");

var $kQ03h = parcelRequire("kQ03h");
var $h2kvC = parcelRequire("h2kvC");

var $bqit2 = parcelRequire("bqit2");

var $djjJM = parcelRequire("djjJM");

var $iYZK1 = parcelRequire("iYZK1");

var $dbKOJ = parcelRequire("dbKOJ");
const $db027e76448a8745$var$emptyEntryPointParams = {};
const $db027e76448a8745$var$emptyEntryPointProps = {};
function $db027e76448a8745$export$e7eb525bc415b4b4({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, ...dropdownProps }) {
    const environmentProvider = (0, $dbKOJ.useRelayEnvironmentProvider)();
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [children, setChildren] = (0, $eJOHy.useState)(null);
    const handleOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsOpen(isOpen);
    }, []);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $db027e76448a8745$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        setChildren(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iYZK1.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $gt9Am.jsx)($db027e76448a8745$var$LoadingState, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $db027e76448a8745$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setChildren,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        onError
    ]);
    const triggerRef = (0, $djjJM.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $eJOHy.useCallback)((triggerProps)=>{
        const mergedRef = (0, $kmlzw.mergeRefs)([
            triggerRef,
            triggerProps.triggerRef
        ]);
        if (typeof trigger === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cdVOR.default), {
            ...triggerProps,
            ref: mergedRef,
            isSelected: isOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h5xWg))), {
                    ...iconProps,
                    size: "small"
                }),
            testId: dropdownProps.testId && `${dropdownProps.testId}--trigger`,
            "aria-label": dropdownProps.label,
            children: trigger
        });
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            triggerRef: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        isOpen,
        dropdownProps.label,
        dropdownProps.testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYTIy.default), {
        ...dropdownProps,
        onOpenChange: handleOpenChange,
        trigger: popupTrigger,
        shouldFitContainer: (0, $3wLc2.fg)('should-render-to-parent-should-be-true-uip-applica') ? false : undefined,
        shouldRenderToParent: (0, $3wLc2.fg)('should-render-to-parent-should-be-true-uip-applica'),
        children: children
    });
}
const $db027e76448a8745$var$spinnerContainerStyles = (0, $h2kvC.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $db027e76448a8745$var$LoadingState() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kQ03h.default), {
        xcss: $db027e76448a8745$var$spinnerContainerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqit2.default), {
            size: "small"
        })
    });
}

});

parcelRegister("c72mo", function(module, exports) {
$parcel$export(module.exports, "propsContext", () => $18e97c10e2b175f9$export$9d37fe52836e5c97);
$parcel$export(module.exports, "PropsProvider", () => $18e97c10e2b175f9$export$4e02b9968dad1f);

var $eJOHy = parcelRequire("eJOHy");
const $18e97c10e2b175f9$var$initialState = {
    issueId: 0,
    issueKey: ''
};
const $18e97c10e2b175f9$export$9d37fe52836e5c97 = /*#__PURE__*/ (0, $eJOHy.createContext)($18e97c10e2b175f9$var$initialState);
const $18e97c10e2b175f9$export$4e02b9968dad1f = ({ issueId: issueId, issueKey: issueKey, workType: workType, isCreateSubTaskAllowed: isCreateSubTaskAllowed, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            issueId: issueId,
            issueKey: issueKey,
            workType: workType,
            isCreateSubTaskAllowed: isCreateSubTaskAllowed,
            onIssueRefetch: onIssueRefetch,
            onIssueDelete: onIssueDelete
        }), [
        issueId,
        issueKey,
        workType,
        isCreateSubTaskAllowed,
        onIssueRefetch,
        onIssueDelete
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18e97c10e2b175f9$export$9d37fe52836e5c97.Provider, {
        value: value
    }, children);
};

});

parcelRegister("662kQ", function(module, exports) {
$parcel$export(module.exports, "meatballMenuEntrypoint", () => $4dfd900c7867b225$export$16a1baa6da8c0f8);

var $hbdPl = parcelRequire("hbdPl");

var $8lv71 = parcelRequire("8lv71");

const $4dfd900c7867b225$export$16a1baa6da8c0f8 = (0, $8lv71.createEntryPoint)({
    root: (0, $hbdPl.JSResourceForInteraction)(()=>(parcelRequire("kMAcT")), {
        moduleId: "d3552130",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kMAcT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("alLor").then(()=>parcelRequire('evxau'));

});


parcelRegister("4eIT5", function(module, exports) {
$parcel$export(module.exports, "Trigger", () => $09dbb8bf0bc5fc36$export$41fb9f06171c75f4);

var $eJOHy = parcelRequire("eJOHy");

var $5Fqnx = parcelRequire("5Fqnx");

var $iea9o = parcelRequire("iea9o");
const $09dbb8bf0bc5fc36$export$41fb9f06171c75f4 = ({ issueId: issueId, triggerRef: triggerRef, ...triggerProps })=>{
    const onTriggerKeyDown = (event)=>{
        // Arrow Up/Down already mapped to table rows and meatball menu trigger should work only on Click
        if (event.key === 'ArrowDown') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Fqnx.default), {
        ...triggerProps,
        id: issueId,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue-navigator-issue-operations.ui.button",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iea9o))),
        ref: triggerRef,
        onKeyDown: onTriggerKeyDown,
        isTooltipDisabled: true
    });
};

});

parcelRegister("lJU2B", function(module, exports) {
$parcel$export(module.exports, "default", () => $53abab7dcd5cf0f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $53abab7dcd5cf0f2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuButton: {
        "id": "issue-navigator-issue-operations.menu-button",
        "defaultMessage": "Issue operations menu"
    },
    menuButtonLabel: {
        "id": "issue-navigator-issue-operations.menu-button-label",
        "defaultMessage": "More actions for {issueKey}"
    },
    disabledMenuButtonLabel: {
        "id": "issue-navigator-issue-operations.disabled-menu-button-label",
        "defaultMessage": "Disabled more actions button for {issueKey}"
    },
    menuButtonIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.menu-button-issue-terminology-refresh-m4",
        "defaultMessage": "Work item operations menu"
    }
});

});



$parcel$global.rlb("alGa0")
//# sourceMappingURL=ui.bffe1cf9.js.map
